import { handleResponse } from './apiService';
import configJson from '../config/config.json';
import { getCointConvertUrl } from './assetsService';

const appendChainId = (url, chainId = configJson.network, isVpool) => {
  const searchParams = new URLSearchParams({ chain_id: chainId, is_vpool: isVpool });
  return `${url}?${searchParams}`;
};

export const getAppConfig = (isVpool) =>
  fetch(appendChainId(`${configJson.apiPath}/config`, window.chainId, isVpool)).then(handleResponse);

export const getCoinConverterRequest = async (base, vs, name) => {
  try {
    const rawRes = await fetch(getCointConvertUrl(base, vs));
    const payload = await rawRes.json();
    return { payload, name };
  } catch (err) {
    return err;
  }
};
